import lt from './lt'
import Utils from '../Utils'

var ltMsg = {
  'agreements.title': 'Sutartys',
  'agreements.error.mandatory': "Turite sutikti, norėdami toliau naudotis „Deeper“ teikiamomis paslaugomis",
  'agreements.error.blank': "Pasirinkite",
  'agreements.back': 'Atgal',
  'agreements.agree': 'Sutikti',
  'agreements.decline': 'Atšaukti',
  'agreements.text.full': 'Visa sutartis'
}

Utils.addTerms(ltMsg, lt)

export default ltMsg



// WEBPACK FOOTER //
// ./src/lang/ltMsg.js